import AgilusDDRCLogo from '@/assets/icons/AgilusDDRCLogo'
import AgilusPhadkeSrlLogo from '@/assets/icons/AgilusPhadkeSrlLogo'
import AgilusSrlLogo from '@/assets/icons/AgilusSrlLogo'

const LOGO_HELPER = () => {
  const subsidiaryLogoMap: Record<string, JSX.Element> = {
    AGILUS: <AgilusSrlLogo className="w-[120px] sm:w-[170px] h-auto" />,
    PHADKE: <AgilusPhadkeSrlLogo className="w-[120px] sm:w-[170px] h-auto" />,
    DDRC: <AgilusDDRCLogo className="w-[75px] sm:w-auto h-auto" />,
  }

  const handleSubsidiaryLogo = (subsidiaryName: string): JSX.Element => {
    return (
      subsidiaryLogoMap[subsidiaryName?.toUpperCase()] ?? (
        <AgilusSrlLogo className="w-[120px] sm:w-[170px] h-auto" />
      )
    )
  }
  return {
    handleSubsidiaryLogo,
  }
}

export default LOGO_HELPER
